import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        topStyle: "white",
        isTopBgShow:false,
        isLineShow:false,
        lineStyle:"left:41px",
        num:null
    },
    mutations: {
        updateTopStyle(state, result) {
            state.topStyle = result;
        },
        updateIsTopBgShow(state, result) {
            state.isTopBgShow = result;
        },
        updateIsLineShow(state, result) {
            state.isLineShow = result;
        },
        updateLineStyle(state, result) {
            state.lineStyle = result;
        },
        updateNum(state, result) {
            state.num = result;
        },
    },
    actions: {}
})
